/** @internal */
export class MessageModel {
  public value: any | undefined;
  public issue: string | undefined;
}
